import { DownloadPdf } from "pages/Downloader/DownloadPdf";
import { TestPdf } from "../pages/Base/TestPdf";
import PublicGuard from "guards/PublicGuard";
import LoginPage from "pages/Login/LoginPage";

export const MainRoutes = [
    {
        element: <PublicGuard />,
        children: [
            {
                index: true,
                path: "/",
                element: <LoginPage />,
            },
            {
                path: "/login",
                element: <LoginPage />,
            },
            {
                path: "/download-pdf/:appNumber",
                element: <DownloadPdf />,
            },
            {
                path: "/test/pdf",
                element: <TestPdf />,
            }
        ]
    },
]
